/* global swal google */
import './style.less';

import { findIndex, get, keyBy } from 'lodash';

import editCertificationModalTemplate from 'modals/editCertification/template.html';
import editCertificationModalCtrl from 'modals/editCertification';

export default function($log, $q, $state, $stateParams, $uibModal, Upload, ProfileClass, ApiClass, Swal, ResolveClass) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  vm.resultsQueried = false;
  vm.passwordChange = false;
  vm.adminEdit = false;

  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const { profile } = ProfileClass.profileComplete;
  const manage = ResolveClass.isManageRoute();

  vm.admin = !!profile.admin;

  function uploadFile(certification, file, s3Policy) {
    certification.uploadProgress = '0%';
    return Upload.upload({
      url: s3Policy.filePolicy.action,
      data: s3Policy.filePolicy.fields,
      file: file,
      method: 'POST',
      skipAuthorization: true
    }).then(
      function() {
        return s3Policy.link;
      },
      function(resp) {
        $log.error('Error status: ' + resp.status);
        throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
      },
      function(evt) {
        const staus = parseInt((100.0 * evt.loaded) / evt.total);
        certification.uploadProgress = `${staus}%`;
      }
    );
  }

  vm.emailAddress = get(ProfileClass, 'profile_complete.company.preferences.certifications.emailAddress', false);

  vm.checkRoute = function(route) {
    return ResolveClass.isAllowedCompanyRoute(route);
  };

  vm.uploadFile = (certification, file) => {
    if (!file) return;
    certification.uploadBtn = true;

    ApiClass.companiesIdTypePut(
      { manage, id: ProfileClass.company_id, type: 'policies' },
      {
        profile_uid,
        policy: 'certification',
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => uploadFile(certification, file, s3Policy))
      .then(link => {
        const miscFile = {
          date: moment()
            .startOf('day')
            .toISOString(),
          name: file.name,
          url: link
        };
        if (!certification.misc_urls) certification.misc_urls = [];
        certification.misc_urls.push(miscFile);
        return update();
      })
      .then(() => {
        certification.uploadBtn = false;
        delete certification.miscFile;
      })
      .catch(error => {
        certification.uploadBtn = false;
        $log.error(error);
        throw error;
      });
  };

  vm.removeFile = (index, params) => {
    const certificationIndex = findIndex(vm.formData.certifications, params);
    vm.formData.certifications[certificationIndex].misc_urls.splice(index, 1);
    update();
  };

  function update() {
    vm.profileUpdate = true;

    return ApiClass.usersIdPatch({ id: profile_uid }, vm.formData)
      .then(() => {
        vm.profileUpdate = false;
        Swal.toast('Certification Updated!');
      })
      .catch(error => {
        if (error.status === 422)
          return Swal.alert('Error', 'Error updating profile, User Sync ID is used by another firm member.', 'error');
        vm.profileUpdate = false;
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  }

  vm.addCertification = certification => {
    if (!vm.formData.certifications) vm.formData.certifications = [];
    vm.formData.certifications.push(certification);

    vm.certificationFormBtn = true;
    ApiClass.usersIdPatch({ id: profile_uid }, { certifications: vm.formData.certifications })
      .then(() => {
        Swal.toast('Certification added!');
        vm.certificationFormBtn = false;
        vm.certificationForm.$setPristine();
        vm.certificationForm.$setUntouched();
        vm.resetCertification();
      })
      .catch(error => {
        vm.certificationFormBtn = false;
        $log.error(error);
        throw error;
      });
  };

  vm.deleteCertification = cert => {
    const index = findIndex(vm.formData.certifications, cert);
    vm.formData.certifications.splice(index, 1);
    ApiClass.usersIdPatch({ id: profile_uid }, { certifications: vm.formData.certifications })
      .then(() => {
        Swal.toast('Certification removed!');
        return vm.resetCertification();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.resetCertification = () => {
    vm.certification = {
      issue_date: moment()
        .startOf('day')
        .toDate(),
      exp_date: moment()
        .startOf('day')
        .toDate()
    };
  };

  vm.editCertification = certification => {
    const index = findIndex(vm.formData.certifications, certification);

    $uibModal
      .open({
        size: 'md',
        backdrop: true,
        template: editCertificationModalTemplate,
        controller: editCertificationModalCtrl,
        controllerAs: 'editCertificationModalCtrl',
        resolve: {
          certification: () => certification
        }
      })
      .result.then(cert => {
        if (!cert) return;

        const certifications = [...vm.formData.certifications];

        certifications[index] = cert;

        return ApiClass.usersIdPatch({ id: profile_uid }, { certifications }).then(() => {
          vm.formData.certifications = certifications;
          Swal.toast('Certification Updated!');
          return vm.resetCertification();
        });
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Users Profile Controller Activated');

    vm.resetCertification();

    const qArr = [
      ApiClass.companiesIdTypeGet({ id: profile.company_id, type: 'certifications', manage: false }),
      ApiClass.usersIdGet({ id: profile_uid }, {}, {})
    ];

    if ($state.$current.name === 'app.admin.employees.employee.profile') {
      vm.adminEdit = true;
    } else {
      vm.passwordChange = true;
    }

    $q.all(qArr)
      .then(([{ data: { items: certifications } }, { data: { item: profile } }]) => {
        vm.certifications = certifications;
        vm.certificationDict = keyBy(vm.certifications, 'id');
        vm.formData = profile;
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/certifications/index.js